import { PRODUCTS_FILTER_TYPE, REDUX_ACTIONS } from "constants/constants";

const initialState = {
  brands: null,
  categories: null,
  rawItems: null,
  items: null,
  containers: [],
  filters: [],
};

const filterItems = (rawItems, nextFilters) => {
  let nextItems = rawItems;

  nextFilters.forEach((filter) => {
    if (filter.filterType === PRODUCTS_FILTER_TYPE.CATEGORY) {
      nextItems = nextItems.filter((ele) => filter.id === ele.catID[0]);
    } else if (filter.filterType === PRODUCTS_FILTER_TYPE.BRANDS) {
      nextItems = nextItems.filter((ele) => filter.id === ele.brand.id);
    } else {
      if (filter.name === "Offers") {
        nextItems = nextItems.filter((ele) => ele.dscnt.length);
      } else if (filter.name === "Featured") {
        nextItems = nextItems.filter((ele) => ele.prio);
      }
    }
  });

  return nextItems;
};

//Each VM has containers in it.
//To show items of a VM, we have to reduce containers array to a single array
const flatContainersItem = function (containers) {
  let rowsAppended = 0;

  //Reduces containers item to a single array.
  let answer = containers.reduce((prev, container) => {
    let length = container.length;

    //Loop through each container and pushes item to the answer.
    container.forEach(function (item) {
      item.pos.row = rowsAppended + item.pos.row;
      prev.push(item);
    });

    //Keep record of how many rows are appended.
    rowsAppended = container[length - 1].pos.row + 1;
    return prev;
  }, []);

  return answer;
};

const vmStockReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.FETCH_VM_STOCK:
      let items = flatContainersItem(action.payload.containers);
      let brands = action.payload.brand;
      return { ...state, ...action.payload, brands, items, rawItems: items };
    case REDUX_ACTIONS.RESET_VM_STOCK:
      return initialState;
    case REDUX_ACTIONS.PUSH_FILTERED_VM_ITEMS:
      return {
        ...state,
        filters: action.payload,
        items: filterItems(state.rawItems, action.payload),
      };
    default:
      return state;
  }
};

export default vmStockReducer;
